import { BitwiseHelper, Message } from '@ncss/message';
import { ByteList } from 'byte-list';

export enum NL4BLERouteRequestMessageType {
  GROUP_MASK = 0x17a0,
}

export class NL4BLERouteRequestMessage extends Message {
  startingPage = 0;
  flags = 0;

  set dropTable(val: boolean) {
    this.flags = BitwiseHelper.SetBits(this.flags, 0, 1, +val);
  }
  set sortTable(val: boolean) {
    this.flags = BitwiseHelper.SetBits(this.flags, 1, 1, +val);
  }
  set radio(val: 1 | 2 | 'both') {
    if (val === 'both') {
      this.flags = BitwiseHelper.SetBits(this.flags, 2, 2, 3);
    } else {
      this.flags = BitwiseHelper.SetBits(this.flags, 2, 2, val);
    }
  }

  constructor(public dstAddress: number, type?: number) {
    super();
    this.type = type || NL4BLERouteRequestMessageType.GROUP_MASK;
    this.radio = 'both';
  }

  public serialize(): ByteList {
    const bytes = super.serialize();
    bytes.writeUInt32(this.dstAddress);
    bytes.writeUInt16(this.startingPage);
    bytes.writeUInt16(this.flags);
    return bytes;
  }

  public deserialize(bytes: ByteList): void {
    super.deserialize(bytes);
    this.dstAddress = bytes.readUInt32();
    this.startingPage = bytes.readUInt16();
    this.flags = bytes.readUInt16();
  }
}
